import MultiSelectList from './MultiSelectList';

export default MultiSelectList;
